import { Suspense } from "react";

import LoadingWheel from "../../components/shared/LoadingWheel";
import NoAccess from "../Error/NoAccess";
import { HelpArticle } from "./helpArticles";
import { useCanReadHelpArticle } from "./useVisibleHelpArticles";

/**
 * Renders one help article, lazily.
 *
 * The /help routes sit under a RequireAuth with no requiredFeature so the index
 * stays reachable by every role, which means per-article gating has to happen
 * here — otherwise anyone could deep-link an admin guide.
 */
export default function HelpArticleRoute({ article }: { article: HelpArticle }) {
  const { allowed, isLoading } = useCanReadHelpArticle(article.slug);
  const Article = article.component;

  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center py-16">
        <LoadingWheel />
      </div>
    );
  }

  if (!allowed) return <NoAccess />;

  return (
    <Suspense
      fallback={
        <div className="flex w-full items-center justify-center py-16">
          <LoadingWheel />
        </div>
      }
    >
      <Article />
    </Suspense>
  );
}
